import type { FC, ReactNode } from 'react';
import FormControl from '@mui/material/FormControl';
import { FormLabel } from '@mui/material';

export const FormControlContainer: FC<{ title: string, children: ReactNode }> = ({ title, children }) => {
  return (
    <FormControl sx={{ width: '100%', flexDirection: 'row', alignItems: 'start', p: 0 }}>
      <FormLabel
        sx={t => ({
          '&': {
            top: 0,
            flex: '0 0 30%',
            fontSize: t.typography.subtitle2,
            color: t.palette.text.primary,
          },
        })}>{title}</FormLabel>
      {children}
    </FormControl>
  );
};